import React from "react";
import { Radio, RadioProps } from "@mui/material";
import { RadioCheckedIcon, RadioCheckIcon } from "../Icons";

const BpRadio = (props: RadioProps) => {
  return (
    <Radio
      disableRipple
      color="default"
      checkedIcon={<RadioCheckedIcon />}
      icon={<RadioCheckIcon />}
      {...props}
    />
  );
};

export default BpRadio;
